// extracted by mini-css-extract-plugin
module.exports = {"wrap-static":"NotFound_wrap-static__2S1_d","wrap-box":"NotFound_wrap-box__31Rvb","box":"NotFound_box__3k0fA","content":"NotFound_content__3MVCK","empty":"NotFound_empty__FnYMg"};